import Head from 'next/head'
import Script from 'next/script'
import React from 'react'
import { attributes } from '../content/global-seo-meta.md'

interface Props {
  title: string
  description: string
  robots?: string
}

const MetaContent: React.FunctionComponent<Props> = ({
  title,
  description,
  robots,
}) => {
  const { ogImage } = attributes

  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <title>{`North Park Transportation: ${title}`}</title>
        <meta name="description" content={description} />
        {robots && <meta name="robots" content={robots} />}
        <meta property="og:url" content="https://nopk.com" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={`North Park Transportation: ${title}`}
        />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta itemProp="name" content={`North Park Transportation: ${title}`} />
        <meta itemProp="description" content={description} />
        <meta itemProp="image" content={ogImage} />
        <link rel="preload" href="/fonts/TTHovesItalic/font.woff" as="font" />
        <link rel="preload" href="/fonts/TTHovesItalic/font.woff2" as="font" />
        <link rel="preload" href="/fonts/TTHovesRegular/font.woff" as="font" />
        <link rel="preload" href="/fonts/TTHovesRegular/font.woff2" as="font" />
        <link rel="preload" href="/fonts/TTHovesBold/font.woff" as="font" />
        <link rel="preload" href="/fonts/TTHovesBold/font.woff2" as="font" />
        <link
          rel="preload"
          href="/fonts/TTHovesBoldItalic/font.woff"
          as="font"
        />
        <link
          rel="preload"
          href="/fonts/TTHovesBoldItalic/font.woff2"
          as="font"
        />
      </Head>
      <Script id="structured-data" async type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          name: 'North Park Transportation',
          image: ogImage,
          '@id': 'https://nopk.com',
          url: 'https://nopk.com',
          telephone: '303-295-0300',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '5150 Columbine St',
            addressLocality: 'Denver',
            addressRegion: 'CO',
            postalCode: '80216',
            addressCountry: 'US',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: 39.7899671,
            longitude: -104.9555869,
          },
        })}
      </Script>
      {/* Load the Netlify Identity widget only when an identity token is in
          the URL (CMS editor invite/recovery links) so ordinary visits make
          no request to identity.netlify.com. */}
      <Script id="netlify-identity-widget">
        {`
          if (/(invite_token|confirmation_token|recovery_token|email_change_token)=/.test(window.location.hash)) {
            var s = document.createElement('script');
            s.src = 'https://identity.netlify.com/v1/netlify-identity-widget.js';
            s.async = true;
            document.head.appendChild(s);
          }
        `}
      </Script>
    </>
  )
}

export default MetaContent
